import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import translationEn from './locales/en/translation.json'
import translationDe from './locales/de/translation.json'
import translationFr from './locales/fr/translation.json'
import translationEs from './locales/es/translation.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    // we init with resources
    resources: {
      en: {
        translations: translationEn,
      },
      de: {
        translations: translationDe,
      },
      fr: {
        translations: translationFr,
      },
      es: {
        translations: translationEs,
      },
    },
    fallbackLng: 'de',
    debug: false,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys
    nsSeparator: false,
    interpolation: {
      formatSeparator: ',',
    },

    react: {
      useSuspense: true,
    },
  })
export default i18n

export const getCurrentLangISO = () => {
  // iso639_2
  const LANGS = { en: 'eng', de: 'ger', fr: 'fre', es: 'spa' }
  return LANGS[i18n.resolvedLanguage]
}

export const updateTranslations = (translations) => {
  const addTranslation = (lng, translation) => {
    i18n.addResourceBundle(lng, 'translations', translation, true, true)
  }

  const { de, en, fr, es } = translations
  addTranslation('de', de)
  addTranslation('en', en ? en : de)
  addTranslation('fr', fr ? fr : de)
  addTranslation('es', es ? es : de)
  i18n.changeLanguage(i18n.language) // trigger re-render
}
